import { Language, type LanguageType } from '../locales';
import { Theme, type ThemeType } from '../themes';
import { ComponentSize, type ComponentSizeType } from '../types/component-size';

const Config = {
  Language,
  Theme,
  ComponentSize,
};

export default Config;

export type { ComponentSizeType, LanguageType, ThemeType };
